module.exports = __webpack_public_path__ + "images/audi_image8.cbda0e9e.png";